import React from "react";

function MoDataComp() {
  const styles = {
    display: "flex",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "x-large",
    fontWeight: "bolder",
  };
  return <div style={styles}>Sytems data not available </div>;
}

export default MoDataComp;
